import Vue from "vue";
import Vuex from "vuex";
//content import
import news from "./news.json";
import books from "./books.json";
import reviews from "./reviews.json";
import awards from "./awards.json";

Vue.use(Vuex);

const state = {
  currentSection: "",
  scrollTo: {
    options: {
      container: "body",
      duration: 500,
      easing: "ease-in",
      offset: -170,
      cancelable: true,
      onDone: false,
      onCancel: false,
      x: false,
      y: true
    }
  },
  news: news,
  books: books,
  reviews: reviews,
  awards: awards
};

const getters = {
  getAwardsSnippet: state => {
    return state.awards.filter(award => {
      return award.id == "award-003" || award.id == "award-005"
    }).sort(function(a, b) {
      if (a.id > b.id) {
       return 1;
     }
     if (a.id < b.id) {
       return -1;
     }
     return 0;
    });
  },
  getBooks: state => {
    return state.books.filter(book => {
      if (state.currentSection == "") {
        return book.section;
      }
      return book.section == state.currentSection;
    });
  },
  getSections: state => {
    return state.books.map(book => {
      return book.section;
    });
  }
};

const mutations = {
  SET_SECTION(state, section) {
    state.currentSection = section;
  },

  SET_SCROLLTO_OFFSET(state, height) {
    state.scrollTo.options.offset = -height;
  }
};

const actions = {};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./client/store/index.js